#
# * classList.js: Cross-browser full element.classList implementation.
# * 1.1.20150312
# *
# * By Eli Grey, http://eligrey.com
# * License: Dedicated to the public domain.
# *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
# 

#global self, document, DOMException 

#! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js

if "document" of self

# Full polyfill for browsers with no classList support
    unless "classList" of document.createElement("_")
        ((view) ->
            "use strict"
            return  unless "Element" of view
            #console.log('creating html classList')
            classListProp = "classList"
            protoProp = "prototype"
            elemCtrProto = view.Element[protoProp]
            objCtr = Object
            strTrim = String[protoProp].trim or ->
                @replace /^\s+|\s+$/g, ""

            arrIndexOf = Array[protoProp].indexOf or (item) ->
                i = 0
                len = @length
                while i < len
                    return i  if i of this and this[i] is item
                    i++
                -1


            # Vendors: please allow content code to instantiate DOMExceptions
            DOMEx = (type, message) ->
                @name = type
                @code = DOMException[type]
                @message = message
                return

            checkTokenAndGetIndex = (classList, token) ->
                throw new DOMEx("SYNTAX_ERR", "An invalid or illegal string was specified")  if token is ""
                throw new DOMEx("INVALID_CHARACTER_ERR", "String contains an invalid character")  if /\s/.test(token)
                arrIndexOf.call classList, token

            ClassList = (elem) ->
                trimmedClasses = strTrim.call(elem.getAttribute("class") or "")
                classes = (if trimmedClasses then trimmedClasses.split(/\s+/) else [])
                i = 0
                len = classes.length
                while i < len
                    @push classes[i]
                    i++
                @_updateClassName = ->
                    elem.setAttribute "class", @toString()
                    return

                return

            classListProto = ClassList[protoProp] = []
            classListGetter = ->
                new ClassList(this)


            # Most DOMException implementations don't allow calling DOMException's toString()
            # on non-DOMExceptions. Error's toString() is sufficient here.
            DOMEx[protoProp] = Error[protoProp]
            classListProto.item = (i) ->
                this[i] or null

            classListProto.contains = (token) ->
                token += ""
                checkTokenAndGetIndex(this, token) isnt -1

            classListProto.add = ->
                tokens = arguments
                i = 0
                l = tokens.length
                token = undefined
                updated = false
                loop
                    token = tokens[i] + ""
                    if checkTokenAndGetIndex(this, token) is -1
                        @push token
                        updated = true
                    break unless ++i < l
                @_updateClassName()  if updated
                return

            classListProto.remove = ->
                tokens = arguments
                i = 0
                l = tokens.length
                token = undefined
                updated = false
                index = undefined
                loop
                    token = tokens[i] + ""
                    index = checkTokenAndGetIndex(this, token)
                    while index isnt -1
                        @splice index, 1
                        updated = true
                        index = checkTokenAndGetIndex(this, token)
                    break unless ++i < l
                @_updateClassName()  if updated
                return

            classListProto.toggle = (token, force) ->
                token += ""
                result = @contains(token)
                method = (if result then force isnt true and "remove" else force isnt false and "add")
                this[method] token  if method
                if force is true or force is false
                    force
                else
                    not result

            classListProto.toString = ->
                @join " "

            if objCtr.defineProperty
                classListPropDesc =
                    get: classListGetter
                    enumerable: true
                    configurable: true

                try
                    objCtr.defineProperty elemCtrProto, classListProp, classListPropDesc
                catch ex # IE 8 doesn't support enumerable:true
                    if ex.number is -0x7FF5EC54
                        classListPropDesc.enumerable = false
                        objCtr.defineProperty elemCtrProto, classListProp, classListPropDesc
            else elemCtrProto.__defineGetter__ classListProp, classListGetter  if objCtr[protoProp].__defineGetter__
            return
        ) self

    else

# There is full or partial native classList support, so just check if we need
# to normalize the add/remove and toggle APIs.
        (->
            "use strict"
            testElement = document.createElement("_")
            testElement.classList.add("c1", "c2")

            # Polyfill for IE 10/11 and Firefox <26, where classList.add and
            # classList.remove exist but support only one argument at a time.
            unless testElement.classList.contains("c2")
                createMethod = (method) ->
                    original = DOMTokenList::[method]
                    DOMTokenList::[method] = (token) ->
                        i = undefined
                        len = arguments.length
                        i = 0
                        while i < len
                            token = arguments[i]
                            original.call this, token
                            i++
                        return

                    return

                createMethod("add")
                createMethod("remove")
            testElement.classList.toggle("c3", false)

            # Polyfill for IE 10 and Firefox <24, where classList.toggle does not
            # support the second argument.
            if testElement.classList.contains("c3")
                _toggle = DOMTokenList::toggle
                DOMTokenList::toggle = (token, force) ->
                    if 1 of arguments and not @contains(token) is not force
                        force
                    else
                        _toggle.call(this, token)
            testElement = null
            return
        )()
